import { useGetFetch } from '../utils/reactQuery';
import { ApiRoutesEnum } from '../utils/routes';

import { StatusType } from './types';

export const useGetRecruitmentStatusDictionary = () =>
  useGetFetch<StatusType[]>({ url: ApiRoutesEnum.recruitmentStatuses });
